const PRIMARY = {
  main: '#1264E7',
  dark: '#0D46A1',
  light: '#5A9CF0',
  soft: '#EAF2FE',
};

const SECONDARY = {
  main: '#E33371',
  dark: '#9A255D',
  light: '#F88FB3',
  soft: '#FFF1F6',
};

const SUCCESS = {
  main: '#2EB670',
  dark: '#1F8E3D',
};

const WARNING = {
  main: '#F5A623',
  dark: '#E2B93B',
};

const ERROR = {
  main: '#EB5757',
  dark: '#EB5757',
};

const INFO = {
  main: '#2D9CDB',
  dark: '#2684FF',
};

const BASE = {
  white: '#FEFEFE',
  black: '#1A1A1A'
};



export const tokens = (mode) => ({
  ...(mode === 'light' ? {
    base: { ...BASE },
    primary: { ...PRIMARY },
    secondary: { ...SECONDARY },
    success: { ...SUCCESS },
    error: { ...ERROR },
    info: { ...INFO },
    warning: { ...WARNING },
    neutral: {
      50: '#F9FAFB',
      100: '#F2F4F7',
      200: '#E4E7EC',
      300: '#D0D5DD',
      400: '#98A2B3',
      500: '#667085',
      600: '#344054',
      700: '#344054',
      800: '#1D2939',
      900: '#101828',
    },
    main_blue: {
      50: '#EEF8FF',
      100: '#E3F0FB',
      200: '#BBE3FF',
      300: '#8DD3FF',
      400: '#57B9FF',
      500: '#3098FF',
      600: '#197AF7',
      700: '#1264E7',
      800: '#154FB8',
      900: '#174691',
      950: '#132B58'
    },
    blue: {
      50: '#F2F8FD',
      100: '#E3F0FB',
      200: '#C1E1F6',
      300: '#8AC93F',
      400: '#4BAEE5',
      500: '#2D9CDB',
      600: '#1676B3',
      700: '#135E91',
      800: '#145078',
      900: '#164364',
      950: '#0F2B42'
    },
    red: {
      50: '#FEF2F2',
      100: '#FDE3E3',
      200: '#FCCCCC',
      300: '#F9A8A8',
      400: '#F47575',
      500: '#EB5757',
      600: '#D62C2C',
      700: '#B42121',
      800: '#951F1F',
      900: '#7C2020',
      950: '#430C0C',
    },
    green: {
      50: '#EEFBF4',
      100: '#D7F4E2',
      200: '#B2E8CA',
      300: '#80D5AC',
      400: '#4BBC89',
      500: '#2EB67D',
      600: '#1A8158',
      700: '#156749',
      800: '#13523A',
      900: '#104431',
      950: '#08261C',
    },
    yellow: {
      50: '#FEF9EC',
      100: '#FDEDC8',
      200: '#FAD98D',
      300: '#F7C152',
      400: '#F5A623',
      500: '#EF8611',
      600: '#D3640C',
      700: '#AF440E',
      800: '#8F3511',
      900: '#752C12',
      950: '#431505',
    },
    indigo: {
      50: '#f0e7ff',
      100: '#d7c3fe',
      200: '#bb9bff',
      300: '#9e6fff',
      400: '#844aff',
      500: '#661fff',
      600: '#581af8',
      700: '#400ef0',
      800: '#1f02eb',
      900: '#0000e7',     
    }
  } : {
    base: { ...BASE },
    primary: { ...PRIMARY },
    secondary: { ...SECONDARY },
    success: { ...SUCCESS },
    error: { ...ERROR },
    info: { ...INFO },
    warning: { ...WARNING },
    neutral: {
      900: '#101828',
      800: '#1D2939',
      700: '#344054',
      600: '#344054',
      500: '#667085',
      50: '#F9FAFB',
      400: '#98A2B3',
      300: '#D0D5DD',
      200: '#E4E7EC',
      100: '#F2F4F7',
    },
    main_blue: {
      950: '#132B58',
      900: '#174691',
      800: '#154FB8',
      700: '#1264E7',
      600: '#197AF7',
      500: '#3098FF',      
      400: '#57B9FF',
      300: '#8DD3FF',
      200: '#BBE3FF',
      100: '#E3F0FB',
      50: '#EEF8FF',
    },
    blue: {
      950: '#0F2B42',
      900: '#164364',
      800: '#145078',
      700: '#135E91',
      600: '#1676B3',
      500: '#2D9CDB',
      400: '#4BAEE5',
      300: '#8AC93F',
      200: '#C1E1F6',
      100: '#E3F0FB',
      50: '#F2F8FD',
    },
    red: {
      950: '#430C0C',
      900: '#7C2020',
      800: '#951F1F',
      700: '#B42121',
      600: '#D62C2C',
      500: '#EB5757',
      400: '#F47575',
      300: '#F9A8A8',
      200: '#FCCCCC',
      100: '#FDE3E3',
      50: '#F2F8FD',      
    },
    green: {
      950: '#08261C',
      900: '#104431',
      800: '#13523A',
      700: '#156749',
      600: '#1A8158',
      500: '#2EB67D',
      400: '#4BBC89',
      300: '#80D5AC',
      200: '#B2E8CA',
      100: '#D7F4E2',
      50: '#EEFBF4',      
    },
    yellow: {
      950: '#431505',
      900: '#752C12',
      800: '#8F3511',
      700: '#AF440E',
      600: '#D3640C',
      500: '#EF8611',
      400: '#F5A623',
      300: '#F7C152',
      200: '#FAD98D',
      100: '#FDEDC8',
      50: '#FEF9EC',      
    }
  })
});
